import React from "react";
import PropTypes from "prop-types";
import { DropDownItem } from "MODULES/shared/components/DropDown";
import { Icon } from "MODULES/shared/components";
import {
  REPAIR_EVALUATION_APPROVED,
  REPAIR_EVALUATION_REJECTED
} from "MODULES/inventories/constants";
import { NO_WORK_PERFORMED, SHOP_ASSIST } from "MODULES/RepairOrders/constants";

export default function ReturnRepairItem({ toggleReturnModal, lineItem }) {
  if (
    ![
      REPAIR_EVALUATION_REJECTED,
      REPAIR_EVALUATION_APPROVED,
      NO_WORK_PERFORMED
    ].includes(lineItem.approval_status) &&
    lineItem.action_requested !== SHOP_ASSIST
  ) {
    return null;
  }

  return (
    <DropDownItem onClick={toggleReturnModal}>
      <Icon name="undo" fixed />
      {lineItem.received ? "Edit Return Details" : "Return Repair Item"}
    </DropDownItem>
  );
}

ReturnRepairItem.propTypes = {
  lineItem: PropTypes.shape({}),
  toggleReturnModal: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/LineItemControls/ReturnRepairItem/ReturnRepairItem.jsx